import { Injectable, inject } from '@angular/core';

import { Fixture } from '@cds/betting-offer';
import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { BettingOfferConfig } from '@frontend/sports/common/client-config-data-access';

/**
 * Processing option groups for which there is a linkeFixture and configured mapping
 * Mapping between templateId and MarketType done in Dynacon
 *
 * @updateLinkedGroups flag OptionGroup if both conditions are true(linkedFixture & mapping),
 * used to show linked golf EW instead of the flagged golf optionGroup
 */
@Injectable({ providedIn: 'root' })
export class LinkedFixtureService {
    private offerConfig = inject(BettingOfferConfig);

    updateLinkedGroups(event: EventModel): EventOptionGroup[] {
        if (event.winGameLinkedFixture) {
            const fixtureMarketType = this.getMarketType(event.winGameLinkedFixture);

            event.optionGroups.forEach((og) => {
                const templateIdMapping = this.offerConfig.golfSiblingMapping[og.templateId];

                if (templateIdMapping === fixtureMarketType) {
                    // eslint-disable-next-line no-param-reassign
                    og.linkedSibling = true;
                }
            });
        }

        return event.optionGroups;
    }

    private getMarketType(fixture: Fixture): string {
        const participant = fixture.participants.find((p) => p.options.length);

        return participant?.options[0].marketType ?? '';
    }
}
